import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function UykuyaDalamamaTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['uykuya-dalamama-testi']} />;
}
